import React from 'react'
import { Row, Col, Card, Container, CardText, CardBody, CardTitle, CardSubtitle } from 'reactstrap'
// import Img from 'gatsby-image'
import Phone from 'react-ionicons/lib/IosPhonePortrait'
import Mail from 'react-ionicons/lib/MdMail'
import { graphql } from 'gatsby'
import Img from 'gatsby-image'
import Layout from '../components/layout'
import SEO from '../components/SEO'
import Map from '../components/Map'

const contact = ({ data }) => {
  const wilrijkImage = data.allFile.edges.filter(
    locationImage => locationImage.node.name === 'wilrijk'
  )[0]

  return (
    <Layout title="Contacteer ons">
      <SEO
        title="Contacteer ons"
        description="Contacteer Isis Wilrijk en leg meteen je afspraak vast."
      />
      <Container className="mt-5">
        <h1>Contacteer ons</h1>
        <Row className="mt-3 mb-4">
          <Col md="6">
            <Card className="mt-3">
              <CardBody>
                <CardTitle tag="h2">Isis Wilrijk</CardTitle>
                <CardSubtitle>Prins-Boudewijnlaan 310 B2610 Wilrijk</CardSubtitle>
              </CardBody>
              {wilrijkImage && <Img fluid={wilrijkImage.node.childImageSharp.fluid} />}
              <CardBody>
                <CardText>
                  Afspraken enkel telefonisch te maken.
                  <a href="tel:+3234493724" className="d-block">
                    <Phone fontSize="20px" color="#20614F" style={{ marginRight: '10px' }} />
                    03/449.37.24
                  </a>
                  <a href="mailto:info@schoonheidsinstituut-isis.be" className="d-block">
                    <Mail fontSize="20px" color="#20614F" style={{ marginRight: '10px' }} />
                    info@schoonheidsinstituut-isis.be
                  </a>
                </CardText>
              </CardBody>
            </Card>
          </Col>
          <Col md="6" />
        </Row>
        <Map />
      </Container>
    </Layout>
  )
}

export default contact

export const query = graphql`
  query locationImageQuery {
    allFile(filter: { relativeDirectory: { eq: "locations" } }) {
      edges {
        node {
          name
          childImageSharp {
            fluid {
              ...GatsbyImageSharpFluid
            }
          }
        }
      }
    }
  }
`
